// extracted by mini-css-extract-plugin
export default {"SubmitButton":"EmployeeOnboardingAvailabilityForm_SubmitButton__I6yAs"};